import { RegistrantsState } from './types';

export const initialState: RegistrantsState = {
  registrants: [],
  registrantsCount: 0,
  loadingRegistrants: false,
  course: null,
  loadingCourse: false,
};
